<template>
    <div class="container">
        <div class="section">
            <hr class="has-background-grey-lighter">
        </div>
    </div>
</template>

<script>
export default {
    name: "Divider"
}
</script>

<style scoped>

</style>